import { useState } from "react";
import { sendPushNotification } from "../api/common.api";
import { useRecoilValue } from "recoil";
import { userListState } from "../atom/atom";
import { PushType } from "../types/type";
import { usePushNotificationForm } from "../hooks/usePushNotificationForm";

type PushNotificationFormProps = {
  onSuccess?: () => void;
  onError?: (error: any) => void;
};

const PushNotificationForm: React.FC<PushNotificationFormProps> = ({
  onSuccess,
  onError,
}) => {
  const {
    title,
    setTitle,
    content,
    setContent,
    screen,
    handleScreenChange,
    type,
    handleTypeChange,
    songId,
    handleSongIdChange,
    songIdError,
    setSongIdError,
    validateSongId,
    token,
    tokenError,
    setToken,
    setTokenError,
    handleSingleSendNotification,
  } = usePushNotificationForm();

  const userList = useRecoilValue(userListState);

  const validateToken = (token: string) => {
    return !/\s/.test(token);
  };

  const handleTokenChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setToken(e.target.value);
    if (tokenError) {
      setTokenError("");
    }
  };

  return (
    <div>
      <h1>Send Push Notification</h1>
      <div>
        <label>
          Title:
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </label>
      </div>
      <div>
        <label>
          Content:
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            style={{ width: "100%", height: "100px" }}
          />
        </label>
      </div>
      <div>
        <label>
          SongId:
          <input
            type="text"
            value={songId}
            onChange={handleSongIdChange}
            style={{
              borderColor: songIdError ? "red" : "",
              borderWidth: songIdError ? "2px" : "1px",
            }}
          />
        </label>
        {songIdError && <div style={{ color: "red" }}>{songIdError}</div>}
      </div>
      <div>
        <label>
          Token:
          <input
            type="text"
            value={token}
            onChange={handleTokenChange}
            style={{
              width: "100%",
              borderColor: tokenError ? "red" : "",
              borderWidth: tokenError ? "2px" : "1px",
            }}
          />
        </label>
        {tokenError && <div style={{ color: "red" }}>{tokenError}</div>}
      </div>
      <div>
        <label>
          Screen:
          <select value={screen} onChange={handleScreenChange}>
            <option value="Recent">Recent</option>
            <option value="MyBrewingList">MyBrewingList</option>
            <option value="Home">Home</option>
            <option value="My">My</option>
          </select>
        </label>
      </div>
      <div>
        <label>
          Type:
          <select value={type} onChange={handleTypeChange}>
            <option value="제조완료">제조완료</option>
            <option value="곡업데이트">곡업데이트</option>
          </select>
        </label>
      </div>
      <button
        onClick={() =>
          handleSingleSendNotification({
            token: token,
            screen: screen,
            songId: songId,
            title: title,
            type: type,
            content: content,
          })
        }
      >
        알림 보내기
      </button>
    </div>
  );
};

export default PushNotificationForm;
